import { type LocalMapStepKeys } from '@src/hooks/useStepRouter'

/** 홈 스탭 검색 input height px*/
export const HOME_SEARCH_INPUT_HEIGHT_PX = 48
/** 홈 스탭 검색 input 상하 padding px */
export const HOME_SEARCH_INPUT_VERTICAL_PADDING_PX = 12
/** 검색 input과 칩 사이의 거리 */
export const HOME_SEARCH_INPUT_CHIP_DISTANCE_PX = 10
/** 홈 스탭 검색 추천 칩 height px */
export const HOME_SEARCH_RECOMMENDATION_CHIP_HEIGHT_PX = 32
/** 검색 스탭 검색 input height px */
export const SEARCH_SEARCH_INPUT_HEIGHT_PX = 44
/** 검색 스탭 검색바 하단 padding px */
export const SEARCH_SEARCH_INPUT_BOTTOM_PADDING_PX = 4
/** 검색 스탭 카테고리 추천 영역 크기 px */
export const SEARCH_SEARCH_CATEGORY_SUGGESTION_AREA_HEIGHT_PX = 48

export const SEARCH_SEARCH_BAR_HEIGHT_PX =
  HOME_SEARCH_INPUT_VERTICAL_PADDING_PX + // 홈 Input과 동일한 높이를 유지하기 위해 홈의 상단 영역 높이를 그대로 적용
  SEARCH_SEARCH_INPUT_HEIGHT_PX + // 검색 input 사이즈
  (HOME_SEARCH_INPUT_HEIGHT_PX - SEARCH_SEARCH_INPUT_HEIGHT_PX) + // 홈 input 사이즈에서 가운데 위치시키기 위한 여백값
  SEARCH_SEARCH_INPUT_BOTTOM_PADDING_PX // 아래 패딩

/** 홈 스탭 상단 영역 height px */
const HOME_TOP_AREA_HEIGHT_PX =
  HOME_SEARCH_INPUT_HEIGHT_PX + // 검색 input
  HOME_SEARCH_INPUT_VERTICAL_PADDING_PX + // 검색 input top padding
  HOME_SEARCH_INPUT_CHIP_DISTANCE_PX + // 검색 input과 칩 사이의 거리
  HOME_SEARCH_RECOMMENDATION_CHIP_HEIGHT_PX // 추천 칩 height

/** 검색 상단 영역 height px */
const SEARCH_TOP_AREA_HEIGHT_PX = SEARCH_SEARCH_BAR_HEIGHT_PX

/** 지도 스탭에 따른 상단영역 height size px */
export const MAP_TOP_AREA_SIZE_MAPPER: Record<LocalMapStepKeys, number> = {
  home: HOME_TOP_AREA_HEIGHT_PX,
  searchResult: SEARCH_TOP_AREA_HEIGHT_PX,
  searchDiscovery: SEARCH_TOP_AREA_HEIGHT_PX,
  preview: HOME_TOP_AREA_HEIGHT_PX,
  searchedPreview: SEARCH_TOP_AREA_HEIGHT_PX,
  storyPreview: HOME_TOP_AREA_HEIGHT_PX,
  externalPage: 0,
}
